import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from './other.slice';
import axios from 'axios';

const initialState = {
    data: [],
    users: [],
    trips: [],
    bookings: [],
    error: null,
    loading: false,
}

export const DriverListReq = createAsyncThunk('DriverListReq', async ({ data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/partner/driver/list`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})


export const DriverTripsReq = createAsyncThunk('DriverTripsReq', async ({ data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/partner/driver/rides`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const allUsersReq = createAsyncThunk('allUsersReq', async ({ rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/partner/dashboard/drivers`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        if (error?.response?.data?.error) {
            dispatch(toastError(error?.response?.data?.error))
        }
        return error;
    }
})

export const partnerBookingReq = createAsyncThunk('partnerBookingReq', async ({ role }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/partner/${role}/bookings`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        if (error?.response?.data?.error) {
            dispatch(toastError(error?.response?.data?.error))
        }
        return error;
    }
})

export const PartnerModuleSlice = createSlice({
    name: 'PartnerModuleSlice',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(DriverListReq.pending, (state, action) => {
            state.loading = true
            state.data = []
            return state
        })
        builder.addCase(DriverListReq.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload.data
            return state
        })
        builder.addCase(DriverListReq.rejected, (state, action) => {
            state.loading = false
            state.data = []
            state.error = 'Error occured'
        })
        builder.addCase(DriverTripsReq.pending, (state, action) => {
            state.loading = true
            state.trips = []
            return state
        })
        builder.addCase(DriverTripsReq.fulfilled, (state, action) => {
            state.loading = false
            state.trips = action.payload.data
            return state
        })
        builder.addCase(DriverTripsReq.rejected, (state, action) => {
            state.loading = false
            state.trips = []
            state.error = 'Error occured'
        })
        builder.addCase(allUsersReq.pending, (state, action) => {
            state.loading = true
            state.users = []
            return state
        })
        builder.addCase(allUsersReq.fulfilled, (state, action) => {
            state.loading = false
            state.users = action.payload.data
            return state
        })
        builder.addCase(allUsersReq.rejected, (state, action) => {
            state.loading = false
            state.users = []
            state.error = 'Error occured'
        })
        builder.addCase(partnerBookingReq.pending, (state, action) => {
            state.loading = true
            state.bookings = []
            return state
        })
        builder.addCase(partnerBookingReq.fulfilled, (state, action) => {
            state.loading = false
            state.bookings = action.payload.data
            return state
        })
        builder.addCase(partnerBookingReq.rejected, (state, action) => {
            state.loading = false
            state.bookings = []
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default PartnerModuleSlice.reducer